import {booleanAttribute, Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

enum _UiSwitchColors {
    primary = 'primary',
    secondary = 'secondary',
    success = 'success',
    danger = 'danger'
}

@Component({
    selector: 'ui-switch',
    templateUrl: './ui-switch.component.html',
    styleUrls: ['./ui-switch.component.scss'],
    standalone: false
})
export class UiSwitchComponent implements OnInit {
    uuid: string;
    get id() {
        return this.uuid + ((this.disabled || this.disableToggle) ? '-disabled' : '');
    }

    @Input() label: string;
    @Input() tooltip: string;
    @Input() value: any;
    @Input() color: keyof typeof _UiSwitchColors = _UiSwitchColors.primary;

    @Input({transform: booleanAttribute}) disabled: boolean = false;
    @Input({transform: booleanAttribute}) disableToggle: boolean = false;
    @Input({transform: booleanAttribute}) checked: boolean = false;
    @Output() checkedChange = new EventEmitter<boolean>();


    ngOnInit(): void {
        this.uuid = uuidv4();
    }

    onToggle(event: Event) {
        if (this.disabled || this.disableToggle) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        const input = event.target as HTMLInputElement;
        this.checked = input.checked;
        this.checkedChange.emit(input.checked);
    }

}
